import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import { useDataTableContext } from '../../Contexts/DataTableContext';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';
import { useAddUser } from '../../../queries';

function AddUser() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const openDialog = useSelector((state) => state.global.openDialog);
    const { register, formState: { errors }, handleSubmit } = useForm();
    const { setReload } = useDataTableContext();

    const { mutate: createUser } = useAddUser()

    const onSubmit = (data) => {
        createUser(data, {
            onSuccess: () => {
                setReload(true);
            },
        })
    };

    return (
        <Dialog
            visible={openDialog.addUser}
            style={{ width: '600px' }}
            breakpoints={{ '960px': '95vw' }}
            header={t('users.member_details')}
            modal className="p-fluid"
            onHide={() => dispatch(toggleDialog("addUser"))}
        >
            <form onSubmit={handleSubmit(onSubmit)} >
                <div className="px-4 my-5">
                    <div className=" ">
                        <label htmlFor="email" className="form-label">
                            {t('form.email')}
                        </label>

                        <input
                            {...register("email", {
                                required: t('users.email_required'),
                                pattern: /^[\w.+-]+@[\w.-]+\.\w{2,}$/
                            })}
                            aria-invalid={errors.email ? "true" : "false"}
                            className={errors.email ? 'form-control is-invalid' : 'form-control'}
                            placeholder={t('form.email')}
                        />

                        {errors.email && <p className='fv-plugins-message-container invalid-feedback'>{errors.email?.message}</p>}
                        {errors?.email?.type === "pattern" && (
                            <p className='fv-plugins-message-container invalid-feedback'>{t('users.email_invalid')}</p>
                        )}
                    </div>

                </div>
                <div className="col-12 text-center d-flex  align-items-end  justify-content-center py-4 border-top border-gray">
                    <button type="reset" className="btn btn-label-secondary me-3" data-bs-dismiss="modal" aria-label="Close" onClick={() => dispatch(toggleDialog("addUser"))}>{t('buttons.cancel')}</button>
                    <button type="submit" className="btn btn-primary me-1">{t('users.invite')}</button>
                </div>
            </form>
        </Dialog>)
}

export default AddUser